const AuthorDetailsPage = () => {

  
  return (
    <div>
      <div>
        <img src="" alt="author" />
        <h2>Author Name</h2>
        <hr />
        <h4>Aliases</h4>
        <h3>Bio</h3>
        <p>
          Nullam suscipit tempor eros sit amet rutrum. Aliquam at vehicula
          sapien. Donec tincidunt risus ut lacus lacinia laoreet. Pellentesque
          habitant morbi tristique senectus et netus et malesuada fames ac
          turpis egestas. Aenean vel condimentum leo, nec maximus ante.
        </p>

        <div>
          <h3>Works</h3>
          <img src="" alt="work_id" />
          <img src="" alt="work_id" />
          <img src="" alt="work_id" />
        </div>
      </div>
    </div>
  );
};

export default AuthorDetailsPage;
